import ProxyBase from '../../../../../../../core/proxies/ProxyBase'

export class Proxy extends ProxyBase {
  getNominalGDP(params) {
    return this.get('NominalGDP', params)
  }
  getRealGDP(params) {
    return this.get('RealGDP', params)
  }
}

export default new Proxy('IndustryOverview/')
